import apiClient from "../config/apiClient";


export const fetchAlltTest = async (data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=services/labs`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
// page limit